import LampiranIII from './LampiranIII';

export default LampiranIII